import React from "react";
import { useSiteContext } from "../../../../../context/SiteContext";
import { useEditCtaContext } from "../../../../../context/EditCtaContext";

const HorizontalTemplateOneOneTwo = ({
  titleText = "THE BEST PRODUCT IS HERE",
  titleFont = "Roboto",
  titleFontSize = "24",
  titleColor = "#FFFFFF",
  titleTextAlign = "center",
  titleIsBold = false,
  titleIsItalic = false,
  titleIsUnderline = false,
  titleUppercase = false,
  titleLetterSpacing,

  subtitleText = "And it's yours today.",
  subtitleFont = "Roboto",
  subtitleFontSize = "20",
  subtitleColor = "#FFFFFF",
  subtitleTextAlign = "center",
  subtitleIsBold = false,
  subtitleIsItalic = false,
  subtitleIsUnderline = false,

  backgroundType = "color",
  backgroundColor = "#3D4F46",
  backgroundImage = null,

  contentImageOne = null,
  contentImageOnePreview = null,

  buttonLabel = "I want it!",
  buttonFont = "Roboto",
  buttonIsBold = false,
  buttonIsItalic = false,
  buttonIsUnderline = false,
  buttonLink = "",
  buttonFontSize = "18",
  buttonFontColor = "#FFFFFF",
  buttonBackgroundColor = "#2EAC52",

  backgroundImagePreview,

  inmeeting = false,
  position = null,
  preview = false,
  onClose,
}) => {
  const { meetingRole, setActiveElement } = useSiteContext();
  const { explicitBoleanCheck } = useEditCtaContext();

  return (
    <div
    className={`relative ${
      !inmeeting
        ? "h-auto"
        : ["top", "bottom"].includes(position)
        ? "h-[150px]"
        : "!h-[89vh] mt-[5%]"
    } w-full flex flex-row mx-auto items-center px-4 md:px-8 overflow-hidden`}
      style={{ backgroundColor }}
    >
      {/* Close Button */}
      {inmeeting && (
        <button
          className="absolute top-2 right-2 z-20 bg-red-500 hover:bg-red-600 text-white rounded-full w-6 h-6 flex items-center justify-center transition-colors"
          title="Close Banner"
          style={{ right: "8px", top: "8px" }}
          onClick={() => {
            if (meetingRole === "moderator") {
              onClose();
            } else {
              setActiveElement(null);
            }
          }}
        >
          <svg
            className="w-3 h-3"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      )}

      {/* Background Image */}
      {(backgroundImage || backgroundImagePreview) && (
        <div
          className="absolute inset-0 w-full h-full opacity-90"
          style={{
            backgroundImage: `url(${
              backgroundImage instanceof File
                ? backgroundImagePreview
                : backgroundImage
            })`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        />
      )}

      {/* Container with three sections */}
      <div className="relative z-10 flex md:flex-row items-center justify-between w-full max-w-7xl mx-auto gap-3 md:gap-4">
        {/* Left Section - Title */}
        <div className="flex items-center justify-center pl-4">
          <h1
            className={`text-center md:text-left ${
              explicitBoleanCheck(titleIsBold) ? "font-bold" : ""
            } ${explicitBoleanCheck(titleIsItalic) ? "italic" : ""} ${
              explicitBoleanCheck(titleIsUnderline) ? "underline" : ""
            } leading-tight`}
            style={{
              color: titleColor,
              fontSize: `${titleFontSize}px`,
              fontFamily: titleFont,
              textAlign: titleTextAlign,
              textTransform: titleUppercase ? "uppercase" : "none",
              ...(titleLetterSpacing ? { letterSpacing: titleLetterSpacing } : {}),
            }}
          >
            {titleText}
          </h1>
        </div>

        {/* Middle Section - Image */}
        <div className="flex items-center justify-center">
          {contentImageOne || contentImageOnePreview ? (
            <img
              src={
                contentImageOne instanceof File
                  ? contentImageOnePreview
                  : contentImageOne
              }
              alt="Product"
              className="h-full w-24 object-contain"
            />
          ) : (
            <img
              src="/image_placeholder.png"
              alt="Product"
              className="h-full object-contain"
            />
          )}
        </div>

        <p
          className={`text-center md:text-right ${
            explicitBoleanCheck(subtitleIsBold) ? "font-bold" : ""
          } ${explicitBoleanCheck(subtitleIsItalic) ? "italic" : ""} ${
            explicitBoleanCheck(subtitleIsUnderline) ? "underline" : ""
          }`}
          style={{
            color: subtitleColor,
            fontSize: `${subtitleFontSize}px`,
            fontFamily: subtitleFont,
            textAlign: subtitleTextAlign,
          }}
        >
          {subtitleText}
        </p>

        <div className="pr-4">
          <button
            className={`px-3 py-2 md:py-3 rounded-full transition-all duration-200 shadow-lg hover:shadow-xl hover:scale-105 ${
              explicitBoleanCheck(buttonIsBold) ? "font-bold" : ""
            } ${explicitBoleanCheck(buttonIsItalic) ? "italic" : ""} ${
              explicitBoleanCheck(buttonIsUnderline) ? "underline" : ""
            } ${buttonLink ? "cursor-pointer" : "cursor-default"}`}
            style={{
              backgroundColor: buttonBackgroundColor,
              color: buttonFontColor,
              fontSize: `${buttonFontSize}px`,
              fontFamily: buttonFont,
            }}
            onClick={() => {
              if (buttonLink) {
                window.open(buttonLink, "_blank");
              }
            }}
          >
            {buttonLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default HorizontalTemplateOneOneTwo;
